module.exports = __webpack_public_path__ + "img/truck-check.c6417515.svg";